export default __webpack_public_path__ + "static/media/comparison-nova-sm.59e4d5d3.jpg";